export const getConfig = (t, data = {}) => [
  [
    { iconName: 'TifManagers', render: () => data.managers || '--' },
    { iconName: 'TifLegacyRegistered', render: () => data.registered || '--' },
  ],
  [
    { iconName: 'TifSafety', render: () => data.safety || '--' },
    { iconName: 'TifStrongGrowth', render: () => data.growth || '--' },
  ],
  [
    { iconName: 'TifMercuryFocus', render: () => data.focus || '--' },
    { iconName: 'TifPartnerSince', render: () => data.partners || '--' },
  ],
]
